export default "__VITE_ASSET__CperJuKT__"